import React from "react";
import image1 from "../../images/WW-Footer-Bear.png";
import image2 from "../../images/WW-Footer-Penguin.png";
import image3 from "../../images/WW-Logo-Footer.png";
import { Link } from "react-router-dom";

import styles from "./index.module.css";

export default function Footer() {
	return (
		<div className={styles.footer}>
			<div className={styles.mainContainer}>
				<div className={styles.bearContainer}>
					<figure>
						<img src={image1} alt="bear" />
					</figure>
				</div>
				<div className={styles.containerInfo}>
					<div className={styles.logoContainer}>
						<figure>
							<img src={image3} alt="wetwillies" />
						</figure>
					</div>
					<nav>
						<ul>
							<li>
								<Link to="/about">ABOUT US</Link>
							</li>
							<li>
								<Link to="/franchise_oppertunities">
									FRANCHISE INFORMATION
								</Link>
								<ul>
									<li>
										<Link to="/franchise_oppertunities">
											FRANCHISE OPPORTUNITIES
										</Link>
									</li>
									<li>
										<Link to="/reasons_to_invest">
											REASONS TO INVEST
										</Link>
									</li>
									<li>
										<Link to="/investment_requirements">
											INVESTMENT REQUIREMENTS
										</Link>
									</li>
									<li>
										<Link to="/faqs">FAQ'S</Link>
									</li>
									<li>
										<Link to="/support">SUPPORT</Link>
									</li>
									<li>
										<Link to="/request_information">
											REQUEST INFORMATION
										</Link>
									</li>
								</ul>
							</li>
							<li>
								<Link to="/request_information">
									GET STARTED
								</Link>
							</li>
						</ul>
					</nav>
				</div>
				<div className={styles.penguinContainer}>
					<figure>
						<img src={image2} alt="penguin" />
					</figure>
				</div>
			</div>
			<div className={styles.footerContainer}>
				<h3>SUPPORT GLOBAL COOLING</h3>
				<p>
					&copy; Wet Willies 2022 | Crafted and Hosted by
					<a
						href="https://thesabresolution.com/"
						style={{ color: "#0f75bd", textDecoration: "none" }}
					>
						{" "}
						Sabre Creative
					</a>
				</p>
			</div>
		</div>
	);
}
